import React, { useState } from 'react'

import { MUIFloatNumberField, type Props as MUIFloatNumberFieldProps } from './MUIFloatNumberField.component'

export interface NumericFloatFieldProps extends Omit<MUIFloatNumberFieldProps, 'value' | 'onChange'> {
  /** The decoded string value (seeds the local state on mount). */
  value: string
  /** Commit the raw typed string; the caller parses it (`toNumber`). */
  onCommit: (value: string) => void
}

/**
 * A float field that keeps exactly what the client typed ("12," mid-edit, an empty field) while the
 * caller stores the parsed number. `value` only seeds it on mount, so it suits fields that never change
 * from elsewhere while shown.
 *
 * @example
 * <NumericFloatField label="Living space" suffix="m2" value={String(area ?? '')} onCommit={(raw) => patch({ area: toOptionalNumber(raw) })} />
 */
export const NumericFloatField: React.FC<NumericFloatFieldProps> = ({ value, onCommit, ...props }) => {
  const [local, setLocal] = useState(value ?? '')

  return (
    <MUIFloatNumberField
      {...props}
      value={local}
      onChange={(next) => {
        setLocal(next)
        onCommit(next)
      }}
    />
  )
}
